import api from "./api";

export const getCustomers = async (search) => {
  return api
    .get({
      endpoint: `/own/find/customers?search=${search}`,
      port: process.env.REACT_APP_PORT_CUST,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
